import React, { useEffect, useRef, useState } from 'react';

import { TagInputProps } from './types';

type InputChangeEvent = React.ChangeEvent<HTMLInputElement>;
type InputKeyboardEvent = React.KeyboardEvent<HTMLInputElement>;

const TagInput = ({
  className = '',
  onCancel = () => {},
  onFinish = () => {},
}: TagInputProps) => {
  const inputRef = useRef<any>(null);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    inputRef.current.focus();
  }, [inputRef]);

  const handleInputChange = ({ target: { value } }: InputChangeEvent) => {
    setInputValue(value);
  };

  const handleKeyDown = ({ code }: InputKeyboardEvent) => {
    code === 'Enter' && onFinish(inputValue);
    code === 'Enter' && setInputValue('');
  };

  return (
    <input
      ref={inputRef}
      className={`
        ${className}
        flex
        justify-center
        items-center
        rounded-xl
        bg-white
        px-3
        w-28
        h-8.5
        text-sm
        font-semibold
        border
        border-grey-10
        hover:border-grey-50
        focus:border-black
        uppercase
        dark:bg-black-real
        dark:border-grey-70
        dark:hover:border-white
      `}
      type="text"
      value={inputValue}
      onChange={handleInputChange}
      onBlur={onCancel}
      onKeyDown={handleKeyDown}
    />
  );
};

export default TagInput;
